import {Action} from '@ngrx/store';
import {type} from '@cosbeni/core';
import {CATEGORY} from '../common/category.common';

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 *
 * The 'type' utility function coerces strings into string
 * literal types and runs a simple check to guarantee all
 * action types in the application are unique.
 */
export interface IAuthActions {
    LOGIN_USER: string;
    LOGIN_SUCCESS: string;
    LOGIN_FAILURE: string;
    SIGNUP_USER: string;
    SIGNUP_SUCCESS: string;
    SIGNUP_FAILURE: string;
    USER_AUTHENTICATED: string;
    AUTH_TOKEN_EXPIRED: string;
    SIGNOUT_USER: string;
    SIGNOUT_SUCCESS: string;
    SIGNOUT_FAILURE: string;
    CHANGE_REDIRECT_URI: string;
}

export const ActionTypes: IAuthActions = {
    LOGIN_USER: type(`${CATEGORY} Login User`),
    LOGIN_SUCCESS: type(`${CATEGORY} Login Success`),
    LOGIN_FAILURE: type(`${CATEGORY} Login Failure`),
    SIGNUP_USER: type(`${CATEGORY} Signup User`),
    SIGNUP_SUCCESS: type(`${CATEGORY} Signup Success`),
    SIGNUP_FAILURE: type(`${CATEGORY} Signin Failure`),
    USER_AUTHENTICATED: type(`${CATEGORY} User Authenticated`),
    AUTH_TOKEN_EXPIRED: type(`${CATEGORY} Auth Token Expired`),
    SIGNOUT_USER: type(`${CATEGORY} Signout User`),
    SIGNOUT_SUCCESS: type(`${CATEGORY} Signout Success`),
    SIGNOUT_FAILURE: type(`${CATEGORY} Signout Failure`),
    CHANGE_REDIRECT_URI: type(`${CATEGORY} Change Redirect Uri`),
};

export class LoginUserAction implements Action {
    type = ActionTypes.LOGIN_USER;
    constructor(public payload: any) {}
}

export class LoginSuccessAction implements Action {
    type = ActionTypes.LOGIN_SUCCESS;
    payload: string = null;
}

export class LoginFailureAction implements Action {
    type = ActionTypes.LOGIN_FAILURE;
    payload: string = null;
}

export class SignupUserAction implements Action {
    type = ActionTypes.SIGNUP_USER;
    constructor(public payload: any) {}
}

export class SignupSuccessAction implements Action {
    type = ActionTypes.SIGNUP_SUCCESS;
    payload: string = null;
}

export class SignupFailureAction implements Action {
    type = ActionTypes.SIGNUP_FAILURE;
    payload: string = null;
}

export class UserAuthenticatedAction implements Action {
    type = ActionTypes.USER_AUTHENTICATED;
    constructor(public payload: any) {}
}

export class AuthTokenExpiredAction implements Action {
    type = ActionTypes.AUTH_TOKEN_EXPIRED;
    payload: string = null;
}

export class SignoutUserAction implements Action {
    type = ActionTypes.SIGNOUT_USER;
    constructor(public payload: any) {}
}

export class SignoutSuccessAction implements Action {
    type = ActionTypes.SIGNOUT_SUCCESS;
    payload: string = null;
}

export class SignoutFailureAction implements Action {
    type = ActionTypes.SIGNOUT_FAILURE;
    payload: string = null;
}

export class ChangeRedirectUriAction implements Action {
    type = ActionTypes.CHANGE_REDIRECT_URI;
    constructor(public payload: string) {}
}

export type Actions
    = LoginUserAction
    | LoginSuccessAction
    | LoginFailureAction
    | SignupUserAction
    | SignupSuccessAction
    | SignupFailureAction
    | UserAuthenticatedAction
    | AuthTokenExpiredAction
    | SignoutUserAction
    | SignoutSuccessAction
    | SignoutFailureAction;
